export enum ValueFactoryType {
    'DIRECT' = 'DIRECT',
    'STATIC' = 'STATIC',
}